module.exports = __webpack_public_path__ + "img/mgt_bg.daac1e82.jpg";